import { executeActions } from './ExecuteAction';

const initState = {
    loadingFlags: {
        "program": true,
        "course": true,
        "chapters": true,
        "pdf-content": false,
        "video-content": false,
        "quiz-content": false,
        "quiz-status": false,
    },
    errors: {},
    quizStatus: null,
    chapter: null,
    section: null,
    unit: null,
    selectedProjectId: null,
    selectedEventId: null,
    cancelSources: {},
    isVideoQuestionWrong: false,
}

export default function PageReducer(state=initState, action) {
    switch (action.type) {
        case executeActions.setQuizStatus:
            return setQuizStatus(state, action);
        case executeActions.setError:
            return setError(state, action);
        case executeActions.toggleSpinner:
            return toggleSpinner(state, action);
        case executeActions.selectChapter:
            return selectChapter(state, action);
        case executeActions.selectSection:
            return selectSection(state, action);
        case executeActions.selectUnit:
            return selectUnit(state, action);
        case executeActions.deselectChapter:
            return deselectChapter(state, action);
        case executeActions.deselectSection:
            return deselectSection(state, action);
        case executeActions.deselectUnit:
            return deselectUnit(state, action);
        case executeActions.selectProject:
            return selectProject(state, action);
        case executeActions.selectEvent:
            return selectEvent(state, action);
        case executeActions.deselectAll:
            return deselectAll(state, action);
        case executeActions.deselectProject:
            return deselectProject(state, action);
        case executeActions.deselectEvent:
            return deselectEvent(state, action);
        case executeActions.setCancelTokenSource:
            return setCancelTokenSource(state, action);
        case executeActions.setIsWrongFlagForVideoAttachmentQuestion:
            return setIsWrongFlagForVideoAttachmentQuestion(state, action);
        default:
            return state;
    }
}

function setIsWrongFlagForVideoAttachmentQuestion(state, action) {
    return {
        ...state,
        isVideoQuestionWrong: action.payload,
    }
}

function setCancelTokenSource(state, {payload, meta}) {
    return {
        ...state,
        cancelSources: {
            ...state.cancelSources,
            [meta.projectId]: payload,
        }
    }
}

function deselectProject(state, action) {
    return {
        ...state,
        selectedProjectId: null,
    }
}

function deselectEvent(state, action) {
    return {
        ...state,
        selectedEventId: null,
    }
}

function deselectAll(state, action) {
    return {
        ...state,
        chapter: null,
        section: null,
        unit: null,
        selectedProjectId: null,
        selectedEventId: null,
    }
}

function selectProject(state, {payload}) {
    return {
        ...state,
        selectedProjectId: payload
    }
}

function selectEvent(state, {payload}) {
    return {
        ...state,
        selectedEventId: payload
    }
}

function selectUnit(state, {payload}) {
    return {
        ...state,
        unit: payload,
    }
}

function deselectUnit(state) {
    return {
        ...state,
        unit: null,
    }
}

function selectSection(state, {payload}) {
    return {
        ...state,
        section: payload,
    }
}

function deselectSection(state) {
    return {
        ...state,
        section: null,
    }
}

function selectChapter(state, {payload}) {
    return {
        ...state,
        chapter: payload,
    }
}

function deselectChapter(state) {
    return {
        ...state,
        chapter: null,
    }
}

function setQuizStatus(state, {payload}) {
    return {
        ...state,
        quizStatus: payload
    }
}

function setError(state, {payload, meta}) {
    return {
        ...state,
        errors: {
            [meta.apiName]: payload
        },
    }
}

function toggleSpinner(state, {payload, meta}) {
    return {
        ...state,
        loadingFlags: {
            ...state.loadingFlags,
            [meta.apiName]: payload,
        },
    }
}